import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box, Button, ListItemButton } from '@mui/material';
import { Link } from 'react-router-dom';
import { ROUTES } from '@/shared/constants';
import { useNavigationVersion } from '../../model/useNavigationVersion';

interface Props {
  readonly expanded: boolean;
}

export function NewVersionSwitcher({ expanded }: Props) {
  const { switchToV2 } = useNavigationVersion();

  return (
    <Box sx={{ position: 'relative', height: 40, width: '100%' }}>
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          opacity: expanded ? 0 : 1,
          pointerEvents: expanded ? 'none' : 'auto',
          transition: 'opacity 0.15s ease-in-out',
        }}
      >
        <ListItemButton
          onClick={switchToV2}
          sx={{
            p: 0.5,
            border: (theme) => `1px solid ${theme.palette.info.light}`,
            borderRadius: 2,
            height: 40,
            width: 40,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'info.main',
          }}
        >
          <InfoOutlinedIcon sx={{ width: 24, height: 24 }} />
        </ListItemButton>
      </Box>

      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          display: 'flex',
          alignItems: 'center',
          gap: 0.75,
          px: 1,
          border: (theme) => `1px solid ${theme.palette.info.light}`,
          borderRadius: 2,
          color: 'info.main',
          fontSize: '0.75rem',
          opacity: expanded ? 1 : 0,
          pointerEvents: expanded ? 'auto' : 'none',
          transition: 'opacity 0.15s ease-in-out',
        }}
      >
        <InfoOutlinedIcon
          sx={{ width: 24, height: 24, flexShrink: 0, ml: -0.125 }}
        />
        <Box
          component="span"
          sx={{
            flex: 1,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            color: 'text.primary',
          }}
        >
          New navigation available
        </Box>
        <Button
          color="info"
          size="small"
          variant="outlined"
          sx={{
            py: 0,
            px: 0.75,
            fontSize: '0.7rem',
            whiteSpace: 'nowrap',
            flexShrink: 0,
          }}
          to={ROUTES.overview}
          component={Link}
          onClick={switchToV2}
        >
          Switch
        </Button>
      </Box>
    </Box>
  );
}
